import React from 'react'

import { useLiveChatQuery } from 'hooks/useLiveChatQuery'

export const LiveQueryController = () => {
  useLiveChatQuery()

  return <></>
}

export default LiveQueryController
